<script>
export default {
  props: ["clr"]
};
</script>
<template>
  <svg
    id="withdraw_icon"
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
  >
    <path id="Path_8105" data-name="Path 8105" d="M0,0H24V24H0Z" fill="none" />
    <path
      id="Path_8106"
      data-name="Path 8106"
      d="M12,17V3m8,18H4M7,8l5-5,5,5"
      fill="none"
      :stroke="clr ? clr : '#002'"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="1.5"
    />
  </svg>
</template>
